import constate from 'constate';
import { useState } from 'react';

const useLogin = () => {
  const [loading, setLoading] = useState(false);

  return {
    loading,
    setLoading,
  };
};

const [LoginProvider, useLoginContext] = constate(useLogin);

export {
  LoginProvider,
  useLoginContext,
};
